import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import Modal from 'react-modal';
import Select from 'react-select';
import { Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import ReactLoading from 'react-loading';

import arrows from '../images/Arrows.png';
import TAP from '../images/TAP.svg';
import AC3 from '../images/ac3.svg';
import SPORTS from '../images/sports.svg';
import WOK from '../images/weblok.svg';
import ICX from '../images/ICX.png';
import upArrow from '../images/UpArrow.png';
import cross from '../images/Cross.svg';

import { useIconSwapService } from './IconSwapService.jsx';
import { round, formatNumber } from '../utils/Conversions';

const tokenCodes = [
  { value: 'ICX', label: 'ICX' },
  { value: 'AC3', label: 'AC3' },
  { value: 'SPORTS', label: 'SPORTS' },
  { value: 'TAP', label: 'TAP' },
  { value: 'WOK', label: 'WOK' },
];

export const CreateSwapModal = ({
  isModalOpen,
  closeModal,
}: CreateSwapModalPropTypes) => {
  const {
    getICXBalance,
    address,
    getTokenBalance,
    createSwap,
    getLastPrice,
  } = useIconSwapService();
  const history = useHistory();
  const classes = useStyles();
  const [swapFromToken, setSwapFromToken] = useState<TokenType>();
  const [swapToToken, setSwapToToken] = useState<TokenType>();
  const [swapFromValue, setSwapFromValue] = useState<string>();
  const [swapToValue, setSwapToValue] = useState<string>();
  const [ICXBalance, setICXBalance] = useState<string>();
  const [tokenBalance, setTokenBalance] = useState();
  const [isPrivateVisible, setIsPrivateVisible] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isCompareVisible, setIsCompareVisible] = useState(false);
  const [taker_address, setTaker_address] = useState();
  const [lastPrice, setLastPrice] = useState<number>();
  const [isSwapping, setIsSwapping] = useState<boolean>(false);

  useEffect(() => {
    // @ts-ignore
    Promise.resolve(getICXBalance(address)).then((data: any) => {
      setICXBalance(data);
    });
    // @ts-ignore
    getTokenBalance();
  }, [address]);

  useEffect(() => {
    disableCreateSwapButton();
    const lastPrice = async () => {
      if (swapFromToken && swapToToken) {
        if (swapFromToken === swapToToken) return;
        // @ts-ignore
        const price = await getLastPrice(
          swapFromToken.value,
          swapToToken.value
        );
        const roundedPrice = round(price, 5);
        setLastPrice(roundedPrice);
      }
    };
    lastPrice();
  }, [swapFromToken, swapToToken, swapFromValue, swapToValue]);

  const handleSwapFromChange = (value: any) => {
    setSwapFromToken(value);
    if (value.value !== 'ICX') {
      setSwapToToken({ value: 'ICX', label: 'ICX' });
    }
  };

  const handleSwapForChange = (value: any) => {
    setSwapToToken(value);
    if (value.value !== 'ICX') {
      setSwapFromToken({ value: 'ICX', label: 'ICX' });
    }
  };

  const handleFromValueChange = (event: any) => {
    setSwapFromValue(event.target.value);
  };

  const handleToValueChange = (event: any) => {
    setSwapToValue(event.target.value);
  };

  const getImage = (direction: string) => {
    if (direction === 'from') {
      switch (swapFromToken?.value) {
        case 'AC3':
          return <IconImage src={AC3} alt="Icon" />;
        case 'SPORTS':
          return <IconImage src={SPORTS} alt="Icon" />;
        case 'WOK':
          return <IconImage src={WOK} alt="Icon" />;
        case 'TAP':
          return <IconImage src={TAP} alt="Icon" />;
        case 'ICX':
          return <IconImage src={ICX} alt="Icon" />;
        default:
          return <NoImage />;
      }
    } else {
      switch (swapToToken?.value) {
        case 'AC3':
          return <IconImage src={AC3} alt="Icon" />;
        case 'SPORTS':
          return <IconImage src={SPORTS} alt="Icon" />;
        case 'WOK':
          return <IconImage src={WOK} alt="Icon" />;
        case 'TAP':
          return <IconImage src={TAP} alt="Icon" />;
        case 'ICX':
          return <IconImage src={ICX} alt="Icon" />;
        default:
          return <NoImage />;
      }
    }
  };

  const showTokenBalance = (direction: string) => {
    getBalance(swapFromToken?.value);
    if (direction === 'from') {
      switch (swapFromToken?.value) {
        case 'ICX':
          return round(ICXBalance, 5);
        default:
          return round(tokenBalance, 5);
      }
    }

    // if (direction === 'to') {
    //   switch (swapFromToken?.value) {
    //     case 'ICX':
    //       return ICXBalance;
    //     default:
    //       return 0;
    //   }
    // }
  };

  const getBalance = (token?: string) => {
    if (token === 'ICX') {
      return;
    }
    // @ts-ignore
    Promise.resolve(getTokenBalance(token)).then((data: any) => {
      setTokenBalance(data);
    });
  };

  const populateFromInput = () => {
    if (swapFromToken?.value === 'ICX') {
      setSwapFromValue(ICXBalance);
    } else {
      setSwapFromValue(tokenBalance);
    }
  };

  const swapTokens = () => {
    const tempSwapFromToken = swapFromToken;
    const tempSwapToToken = swapToToken;
    const tempSwapFromValue = swapFromValue;
    const tempSwapToValue = swapToValue;

    setSwapFromToken(tempSwapToToken);
    setSwapToToken(tempSwapFromToken);
    setSwapFromValue(tempSwapToValue);
    setSwapToValue(tempSwapFromValue);
  };

  // TODO - Disable button when balance enetered is greater than balance held
  const disableCreateSwapButton = () => {
    if (!swapFromToken || !swapToToken || !swapFromValue || !swapToValue) {
      return setIsDisabled(true);
    }

    setIsDisabled(false);
  };

  const handlePrivateAddress = (event: any) => {
    setTaker_address(event.target.value);
  };

  const createTokenSwap = async () => {
    setIsDisabled(true);
    setIsSwapping(true);
    // @ts-ignore
    const swap = await createSwap(
      swapFromToken,
      swapFromValue,
      swapToToken,
      swapToValue,
      taker_address
    );

    if (!swap) {
      return closeModal();
    }
    history.push(`/makeSwap/${swapFromToken!.value}/${swap.swapId}`);
    closeModal();
  };

  const showLastPrice = (fromValue: string, toValue: string) => {
    return (
      <CompareBodyText>
        {fromValue === 'ICX' ? 1 : lastPrice} {fromValue} &asymp;{' '}
        {toValue === 'ICX' ? 1 : lastPrice} {toValue}
      </CompareBodyText>
    );
  };

  const showModalVariations = () => {
    if (swapFromToken && swapToToken && swapFromValue && swapToValue) {
      return (
        <CompareWrapper>
          <CompareTextWrapper
            onClick={() => {
              setIsCompareVisible(!isCompareVisible);
            }}
          >
            <CompareOfferDropdownText>
              Compare Your Offer
              {isCompareVisible ? (
                <SwitchCaret src={upArrow} alt="arrow" />
              ) : (
                <SwitchCaretDown src={upArrow} alt="arrow" />
              )}
            </CompareOfferDropdownText>
          </CompareTextWrapper>
          {isCompareVisible ? (
            <CompareOfferDropdown>
              <LastPriceWrapper>
                <CompareHeadingText>Last Price</CompareHeadingText>

                {showLastPrice(swapToToken.value, swapFromToken.value)}
              </LastPriceWrapper>
              <LastPriceWrapper>
                <CompareHeadingText>Your Offer</CompareHeadingText>
                <CompareBodyText>
                  1 {swapFromToken.value} &asymp;{' '}
                  {formatNumber(
                    parseInt(swapToValue) / parseInt(swapFromValue)
                  )}{' '}
                  {swapToToken.value}
                </CompareBodyText>
              </LastPriceWrapper>
            </CompareOfferDropdown>
          ) : (
            <CompareInvisible />
          )}
        </CompareWrapper>
      );
    }

    return <PaddingDiv />;
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      style={
        isPrivateVisible || isCompareVisible ? privateModalStyled : modalStyled
      }
    >
      <ModalHeader>
        <TextWrapper>
          <ModalHeading>Create your swap</ModalHeading>
          <ModalText>Your swap must be paired with ICX.</ModalText>
          <Link to={'/faq'} style={{ textDecoration: 'none' }}>
            <GreenModalText>Learn how it works</GreenModalText>
          </Link>
        </TextWrapper>
        <CrossImage src={cross} alt="Close" onClick={() => closeModal()} />
      </ModalHeader>
      <ModalBody height={isPrivateVisible || isCompareVisible ? true : false}>
        <SwappingFormWrapper>
          <SwappingForText>I am swapping</SwappingForText>
          <Select
            value={swapFromToken}
            options={tokenCodes}
            onChange={handleSwapFromChange}
            styles={customStyles}
            placeholder={'Select'}
          />
          <SwappingForText>for</SwappingForText>
          <Select
            value={swapToToken}
            options={tokenCodes}
            onChange={handleSwapForChange}
            styles={customStyles}
            placeholder={'Select'}
          />
        </SwappingFormWrapper>
        <SwapInputsWrapper>
          <InputWrapper>
            <InputLabelText>From</InputLabelText>
            <FakeInput>
              {getImage('from')}
              <SwapInput
                type="number"
                placeholder={'0'}
                value={swapFromValue}
                onChange={handleFromValueChange}
              />
            </FakeInput>
            {swapFromToken && (
              <TokenBalance onClick={populateFromInput}>
                Available: {showTokenBalance('from')} {swapFromToken?.value}
              </TokenBalance>
            )}
          </InputWrapper>
          <ArrowImageWrapper isBalanceShowing={!!swapFromToken}>
            <ArrowsImage src={arrows} alt="Arrows" onClick={swapTokens} />
          </ArrowImageWrapper>
          <InputWrapper>
            <InputLabelText>To</InputLabelText>
            <FakeInput>
              {getImage('to')}
              <SwapInput
                type="number"
                placeholder={'0'}
                value={swapToValue}
                onChange={handleToValueChange}
              />
            </FakeInput>
            {/* {showTokenBalance('to')} */}
          </InputWrapper>
        </SwapInputsWrapper>
        {showModalVariations()}
        <PrivateSwapWrapper>
          <SwitchText>Make this swap private?</SwitchText>

          <Switch
            onChange={() => {
              setIsPrivateVisible(!isPrivateVisible);
            }}
            classes={{
              root: classes.root,
              switchBase: classes.switchBase,
              checked: classes.checked,
              track: classes.track,
              thumb: classes.thumb,
            }}
          />
        </PrivateSwapWrapper>
        {isPrivateVisible && (
          <WalletInputWrapper>
            <WalletInputLabel>Wallet Address</WalletInputLabel>
            <WalletInput
              placeholder={'What address can claim this swap'}
              onChange={handlePrivateAddress}
            />
          </WalletInputWrapper>
        )}
      </ModalBody>
      <ModalFooter>
        <SwapButton
          onClick={() => {
            createTokenSwap();
          }}
          disabled={isDisabled}
        >
          {!isDisabled ? (
            <ButtonText>Create your swap</ButtonText>
          ) : !isSwapping ? (
            <ButtonText>Create your swap</ButtonText>
          ) : (
            <ReactLoading type="spin" height={'35px'} width={'35px'} />
          )}
        </SwapButton>
      </ModalFooter>
    </Modal>
  );
};

export default CreateSwapModal;

type CreateSwapModalPropTypes = {
  isModalOpen: boolean;
  closeModal: () => void;
};

const modalStyled = {
  content: {
    top: '50%',
    left: '50%',
    height: '600px',
    width: '691px',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    overflow: 'hidden',
  },
  overlay: {
    backgroundColor: 'rgba(33, 33, 33, 0.8)',
  },
};

const privateModalStyled = {
  content: {
    top: '50%',
    left: '50%',
    height: '800px',
    width: '691px',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    overflow: 'hidden',
  },
  overlay: {
    backgroundColor: 'rgba(33, 33, 33, 0.8)',
  },
};

const ModalHeader = styled.div`
  height: 135px;
  background-color: #ffffff;
  padding: 30px;
  display: flex;
  flex-direction: row;
`;

const ModalHeading = styled.h3`
  font-family: 'Avenir Next';
  font-size: 26px;
  margin-bottom: 15px;
  font-weight: 600;
`;

const ModalText = styled.span`
  font-family: 'Avenir Next';
  font-size: 16px;
`;

const GreenModalText = styled.span`
  font-family: 'Avenir Next';
  font-size: 16px;
  color: #007d81;
  margin-left: 5px;
`;

const ModalBody = styled.div`
  background-color: #f1f8fc;
  ${(props: ModalBodyHeightType) =>
    css`
      height: ${props.height ? '555px' : '355px'};
    `}
  overflow: scroll;
  padding-top: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: #e8ebec;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #e8ebec;
`;

const SwappingFormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const SwappingForText = styled.span`
  font-style: 'Avenir Next';
  font-size: 20px;
  font-weight: 600;
  margin-left: 15px;
  margin-right: 15px;
`;

const customStyles = {
  control: (base: any) => ({
    ...base,
    width: '100px',
    height: '50px',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '#D3D7E0',
    fontFamily: 'Avenir Next Medium',
    fontSize: '15px',
    backgroundColor: '#FFFF',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
};

const SwapInputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputLabelText = styled.span``;

const ArrowImageWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  justify-content: center;
  align-items: center;
  ${(isBalanceShowing: BalanceProps) =>
    css`
      margin-bottom: ${isBalanceShowing ? '25px' : '0px'};
    `}
`;

const ArrowsImage = styled.img`
  width: 20px;
  height: 28px;
  margin-left: 30px;
  margin-right: 30px;
`;

const FakeInput = styled.div`
  height: 60px;
  width: 225px;
  border: 1px solid #d3d7e0;
  border-radius: 4px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
`;

const IconImage = styled.img`
  width: 41px;
  height: 41px;
  margin-left: 10px;
`;

const NoImage = styled.div`
  width: 41px;
  height: 41px;
  margin-left: 10px;
`;

const SwapInput = styled.input`
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  text-align: right;
  padding-right: 15px;
  border-radius: 5px;
  height: 58px;
  width: 170px;
  border: 0;
  outline-width: 0;
`;

const TokenBalance = styled.span`
  color: rgba(9, 8, 9, 0.4);
  font-family: 'Avenir Next';
  font-size: 13px;
  text-align: right;
  margin-top: 5px;
`;

const CompareWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
`;

const CompareOfferDropdownText = styled.span`
  color: #007d81;
  font-family: 'Avenir Next';
  font-size: 13px;
  font-weight: 500;
`;

const CompareOfferDropdown = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const LastPriceWrapper = styled.div`
  width: 265px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
`;

const CompareHeadingText = styled.span`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 13px;
  font-weight: 500;
`;

const CompareBodyText = styled.span`
  color: #0e0d0e;
  font-family: 'Avenir Next';
  font-size: 13px;
`;

const CompareInvisible = styled.div`
  height: 30px;
  width: 100%;
`;

const PrivateSwapWrapper = styled.div`
  height: 85px;
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: #e8ebec;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SwitchText = styled.span`
  font-family: 'Avenir Next';
  size: 15px;
  margin-right: 20px;
`;

const useStyles = makeStyles({
  root: {
    width: '90px',
    height: '50px',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  track: {
    width: '40px',
    height: '20px',
    borderRadius: '10px',
  },
  switchBase: {
    '&$checked': {
      color: '#007D81',
      transform: 'translateX(40px)',
    },
    '&$checked + $track': {
      backgroundColor: 'rgba(0,125,129,0.3)',
    },
  },
  checked: {},
  thumb: {
    width: '32px',
    height: '32px',
    transform: 'translateX(0px)',
  },
});

const WalletInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ::placeholder {
    color: rgba(0, 0, 0, 0.25);
    font-family: 'Avenir Next';
    font-size: 15px;
    font-weight: 500;
  }
`;

const WalletInputLabel = styled.label`
  color: #100f10;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const WalletInput = styled.input`
  height: 60px;
  width: 530px;
  border: 1px solid #d3d7e0;
  border-radius: 4px;
  background-color: #ffffff;
  padding-left: 15px;
`;

const ModalFooter = styled.div`
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SwapButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  background-color: #007d81;
  height: 50px;
  width: 230px;
  border-radius: 4px;
  opacity: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props: any) =>
    css`
      opacity: ${props.disabled ? 0.5 : 1};
    `};
`;

const ButtonText = styled.span`
  font-size: 16px;
  color: #fff;
`;

const PaddingDiv = styled.div`
  height: 71.5px;
`;

const CompareTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const SwitchCaret = styled.img`
  height: 7px;
  width: 12px;
  margin-left: 3px;
`;

const SwitchCaretDown = styled.img`
  height: 7px;
  width: 12px;
  margin-left: 3px;
  transform: rotate(180deg);
`;

const TextWrapper = styled.div``;

const CrossImage = styled.img`
  height: 14.82px;
  width: 14px;
  margin-left: auto;
  cursor: pointer;
`;

type TokenType = {
  value: string;
  label: string;
};

type ModalBodyHeightType = {
  height: boolean;
};

type BalanceProps = {
  isBalanceShowing: boolean;
};
